export default __webpack_public_path__ + "9fe3d3c956539132680aecbae309084c.png";